import React from 'react';
import { TCodeBlockData } from '../types';
import Typo from '../../Typography';
import { getHighlightSelectionTipProps } from '../withHighlightSelectionTip';

import { withHighlightAsElement } from '../../Highlight/services/withHighlightAsElement';
import { HighlightSelectionHint, TCodeHighlightBlockData } from '../../Highlight/types';

export const renderCode = ({ code }: TCodeBlockData, highlightData?: TCodeHighlightBlockData) => {
  const { code: highlightCode } = highlightData || {};
  return (
    <Typo
      variant="article-p"
      text={
        <code {...getHighlightSelectionTipProps(HighlightSelectionHint.Code)}>
          {withHighlightAsElement(code, highlightCode)}
        </code>
      }
    />
  );
};
